import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl(orderNo) {
  return `v3/stock/orderlist/${orderNo}`;
}

/**
 * @typedef {import('./typedefs').OrderRegularDetailResponse}     Response
 * @typedef {import('@helpers/fetcher').FetchResponse<Response>}  OrderRegularDetailResponse
 */

/**
 *
 * @param {string} url
 * @returns
 */
function callbackFetch(url) {
  return async () => {
    try {
      /**
       * @type {OrderRegularDetailResponse}
       */
      const res = await fetcher.get(url);

      return res.data?.result.results[0];
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function fetch(orderNo) {
  const url = getUrl(orderNo);
  const cb = callbackFetch(url);
  const key = [url, orderNo];

  return { cb, key };
}
